(function () {
  const VARIANT_ID = '64931413360989';

  function updateCartActions(count) {
    document.querySelectorAll('.llaves-shop__bag').forEach((bag) => {
      bag.dataset.cartCount = String(count);
      bag.textContent = count > 0 ? `Bag (${count})` : 'Bag';
    });

    document.querySelectorAll('.llaves-shop__checkout').forEach((checkout) => {
      checkout.classList.toggle('is-hidden', count === 0);
    });
  }

  function openCart(trigger) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      window.location.href = window.routes?.cart_url || '/cart';
      return;
    }
    drawer.open(trigger);
  }

  async function addVariantToCart(variantId, trigger) {
    const drawer = document.querySelector('cart-drawer');
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (drawer) {
      formData.append(
        'sections',
        drawer.getSectionsToRender().map((section) => section.id).join(',')
      );
      formData.append('sections_url', window.location.pathname);
    }

    const response = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });

    const data = await response.json();
    if (data.status) {
      throw new Error(data.description || 'Could not add to bag.');
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'llaves-cart',
        productVariantId: variantId,
        cartData: data,
      });
    }

    updateCartActions(data.item_count);

    if (drawer) {
      drawer.classList.remove('is-empty');
      drawer.renderContents(data);
      return;
    }

    openCart(trigger);
  }

  function initBag(bag) {
    if (bag.dataset.llavesBagInit) return;
    bag.dataset.llavesBagInit = 'true';

    bag.addEventListener('click', () => {
      openCart(bag);
    });
  }

  function initLegacyAddLink(link) {
    if (link.dataset.llavesAddInit) return;
    link.dataset.llavesAddInit = 'true';

    link.addEventListener('click', async (event) => {
      event.preventDefault();
      link.setAttribute('aria-disabled', 'true');

      try {
        await addVariantToCart(VARIANT_ID, link);
      } catch (error) {
        console.error(error);
        window.alert(error.message || 'Could not add to bag.');
      } finally {
        link.removeAttribute('aria-disabled');
      }
    });
  }

  function initProductForm(form) {
    if (form.dataset.llavesFormInit || !form.classList.contains('form')) return;
    if (!form.closest('product-form')) return;
    form.dataset.llavesFormInit = 'true';
  }

  function initAll() {
    document.querySelectorAll('.llaves-shop__bag').forEach(initBag);
    document.querySelectorAll('.llaves-shop__link').forEach((link) => {
      if (link.textContent.trim().toLowerCase().includes('add to bag')) {
        initLegacyAddLink(link);
      }
    });
    document.querySelectorAll('.llaves-shop__fallback-form').forEach((form) => {
      if (form.dataset.llavesFallbackInit) return;
      form.dataset.llavesFallbackInit = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const id = form.querySelector('[name="id"]')?.value || VARIANT_ID;
        await addVariantToCart(id, form.querySelector('[type="submit"]'));
      });
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const count = event.cartData?.item_count;
      if (typeof count !== 'number') return;
      updateCartActions(count);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
